import React from 'react';

import styles from './WalletEvent.module.css';

interface IWalletEvent {
  walletNumber: string;
  walletName: string;
}

const WalletClick = ({ walletNumber, walletName }: IWalletEvent) => (
  <div className={styles.container}>
    <div className={styles.walletNumber}>{walletNumber}</div>
    <div className={styles.walletName}>{walletName}</div>
  </div>
);

export default WalletClick;
